export default "__VITE_ASSET__DB68iObX__"